<script setup lang="ts">
const props = defineProps<{
  title: string
  image?: {
    src: string
    alt?: string
  }
}>()
</script>

<template>
  <ApplicationPageHeader>
    <ImageCover v-if="props.image" :src="props.image.src" class="absolute inset-0 z-0 opacity-60 mix-blend-multiply grayscale" />
    <h1 class="z-10 text-pretty text-center font-logo text-3xl font-bold tracking-wider text-secondary-50 text-shadow text-shadow-xl text-shadow-green-900 lg:text-6xl">
      {{ props.title }}
    </h1>
  </ApplicationPageHeader>
</template>
